import {JwtHelperService} from "@auth0/angular-jwt";

export class JwtToken {
  private token: string;
  private _decodedToken: any;
  get SessionUid(): string {
    return this._decodedToken.SessionUid;
  }
  get Roles(): string[] | null
  {
    try {
      return this._decodedToken.Roles.split(',');
    } catch {
      return null;
    }
  }
  isInRole(roleName: string): boolean {
    const result = this.Roles !== null && this.Roles.some(i => i.toLowerCase() === roleName.toLowerCase())
    //console.log(`Checking role: ${roleName} = ${result}`);
    return result;
  }
  get isExpired(): boolean {
    return this._decodedToken.isExpired;
  }
  get isValid(): boolean {
    return this._decodedToken != null && !this._decodedToken.isExpired;
  }
  get UserName(): string {
    return this._decodedToken.UserName;
  }
  constructor(token: string | null) {
    const helper = new JwtHelperService();
    if (token !== null) {
      this.token = token;
      this._decodedToken = helper.decodeToken(token);
    } else {
     this.token = '';
     this._decodedToken = null;
    }


  }
}
